import useSWR, { type SWRResponse } from "swr";
import { useApiClient } from "@/hooks/useApiClient";
import {
  CORPORATE_MASTER_LIST_API_PATH,
  buildCorporateListQuery,
  getCorporateMasterList,
} from "../api";
import { inlineErrorSwrOptions } from "./inlineErrorSwrOptions";
import type { CorporateListParams, CorporateListResponse } from "../types";

/**
 * 法人マスタを検索する
 * @param params 検索条件（未指定の条件は送らない）
 * @returns SWRレスポンス
 */
export const useCorporateMasterList = (
  params: CorporateListParams
): SWRResponse<CorporateListResponse, Error> => {
  const { apiClient } = useApiClient();
  const query = buildCorporateListQuery(params);
  return useSWR<CorporateListResponse, Error>(
    [CORPORATE_MASTER_LIST_API_PATH, query],
    async () => await getCorporateMasterList(apiClient, query),
    {
      revalidateOnFocus: false,
      ...inlineErrorSwrOptions,
    }
  );
};
